import React from "react";
import AdminNavbar from "../components/Navbar";
import Home from "./cpages/Home";



const AdminPage = () => {
  return (
    <>
      <Home />
  
      
    </>
  );
};

export default AdminPage;
